<template>
  <div style="height: 100%">
    <ul class="table_title">
      <li style="width: 15%">场馆</li>
      <li style="width: 15%">项目</li>
      <li style="width: 15%">预定时间</li>
      <li style="width: 20%">预订场次</li>
      <li style="width: 10%">单价</li>
      <li style="width: 10%">订单状态</li>
      <li style="width: 15%">操作</li>
    </ul>
    <div class="table_content">
      <div v-for="(item, index) in orderList" :key="'order'+ index" class="table_list">
        <ul class="order_ul">
          <li>订单编号：{{ item.orderNumber }}</li>
          <li>订单时间：{{ item.createTime }}</li>
          <li>总价：￥{{ item.totalAmount }}</li>
        </ul>
        <div>
          <ul class="order_detail_ul">
            <li style="width: 15%">{{ item.venueName }}</li>
            <li style="width: 15%">{{ item.projectName }}</li>
            <li style="width: 15%">{{ item.predetermineDate }}</li>
            <li style="width: 20%;">
              <p v-for="(ol, oi) in item.childOrderList" :key="oi">
                {{ ol.venueReservation }} {{ ol.scheduledTime }}
              </p>
            </li>
            <li style="width: 10%">
              <p v-for="(ol, oi) in item.childOrderList" :key="oi">
                ￥{{ ol.orderPrice }}
              </p>
            </li>
            <li style="width: 10%">
              {{ statusList[item.status] }}
            </li>
            <li style="width: 15%">
              <span style="color:#FF4D4D" @click="cancelOrder(item.id)" v-show="item.status !== 4">取消订单</span>
              <span @click="detailOrder(item)">订单详情</span>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="orderList.length === 0" style="text-align: center;padding: 20px;color: #999">暂无订单</div>
    </div>

    <el-dialog :visible.sync="detailVisible" title="订单详情" width="800px">
      <el-form label-width="150px">
        <el-form-item label="订单状态：">{{ statusList[detailData.status] }}</el-form-item>
        <el-form-item label="项目：">{{ detailData.projectName }}</el-form-item>
        <el-form-item label="预定时间：">{{ detailData.predetermineDate }}</el-form-item>
        <el-form-item label="预定场次：">
          <div class="cc_list">
            <div v-for="(ol, oi) in detailData.childOrderList" :key="oi" class="cc_item">
              {{ ol.venueReservation }} {{ ol.scheduledTime }}
            </div>
          </div>
        </el-form-item>
        <el-form-item label="场次单价：">
          <table class="cc_table">
            <tr v-for="(ol, oi) in detailData.childOrderList" :key="oi">
              <td>{{ ol.venueReservation }} {{ ol.scheduledTime }}</td>
              <td>￥{{ ol.orderPrice }}</td>
              <td>
                <el-image :src="require('../../../../assets/image/gzh1.png')"
                          :preview-src-list="[require('../../../../assets/image/gzh1.png')]"
                          style="width: 50px;height: 50px"></el-image>
              </td>
            </tr>
          </table>
        </el-form-item>
        <el-form-item label="合计：">￥{{ detailData.totalAmount }}</el-form-item>
        <el-form-item label="订单编号：">{{ detailData.orderNumber }}</el-form-item>
        <el-form-item label="订单时间：">{{ detailData.createTime }}</el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { get } from '@/utils/request'

export default {
  name: "tableOrder",
  props: {
    orderList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      statusList: ['', '待付款', '待使用', '已完成', '已取消', '已过期', '已退款'],
      detailVisible: false,
      detailData: {}
    }
  },
  methods: {
    cancelOrder (id) {
      this.$confirm('确认取消该订单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$postAction('/gateway/venue-order/cancel', { id }).then(res => {
          if (res.code === 0) {
            this.$message.success('取消成功')
            this.$emit('getData')
          }
        })
      }).catch(() => {
      });
    },

    detailOrder (item) {
      this.detailData = item
      this.detailVisible = true
    }
  }
}
</script>

<style lang="less" scoped>
.table_title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #EFEFEF;
  border: 1px solid #DCDCDC;
  border-bottom: none;
  margin: 0;
  padding: 0;

  li {
    list-style: none;
    width: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    font-weight: 400;
    font-size: 20px;
    color: #333333;
  }
}

.table_content {
  overflow-y: auto;
  height: calc(100% - 80px);
}

.table_list {
  margin-bottom: 10px;
}

.order_ul {
  display: flex;
  align-items: center;
  margin: 0;
  //justify-content: space-between;
  background-color: #F9F9F9;
  border-left: 1px solid #DCDCDC;
  border-right: 1px solid #DCDCDC;
  border-top: 1px solid #DCDCDC;
  padding: 0 5%;

  li {
    list-style: none;
    display: flex;
    align-items: center;
    //justify-content: center;
    height: 52px;
    font-weight: 700;
    font-size: 16px;
    color: #333333;
    margin-right: 20px;

  }
}

.order_detail_ul {
  margin: 0;
  display: flex;
  justify-content: space-between;
  border: 1px solid #DCDCDC;
  padding: 0;

  li {
    list-style: none;
    min-height: 52px;
    width: 120px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #DCDCDC;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
    padding: 10px 0;
    //padding: 10px 0;

    &:last-child {
      border: none;
    }

    p {
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: 1px solid #DCDCDC;
      margin: 0;
      width: 100%;
      height: 52px;

      &:last-child {
        border: none;
      }
    }

    span {
      cursor: pointer;
      margin-bottom: 10px;
      color: #0058A6;

      &:last-child {
        margin: 0;
      }
    }
  }
}

.cc_list {
  display: flex;
  flex-wrap: wrap;

  .cc_item {
    background: #0058a61a;
    border-radius: 4px;
    padding: 0 18px;
    font-size: 14px;
    color: #333333;
    margin: 0 5px 5px 0;
  }
}

.cc_table {
  border-collapse: collapse;
  width: 100%;
  text-align: center;
  line-height: normal;
}

.cc_table td {
  border: 1px solid #DCDCDC;
}
</style>
